module.exports = __webpack_public_path__ + "static/media/6.86da6d3b.jpg";